<custom-cx-nagivation-ui
  *ngIf="(uid$ | async) == 'MyAccountComponent'"
  [node]="node$ | async"
  [ngClass]="styleClass$ | async"
>
</custom-cx-nagivation-ui>

<!-- <cx-navigation-ui *ngIf="(uid$ | async) !== 'MyAccountComponent'">
</cx-navigation-ui> -->

<app-custom-navigation-ui
  *ngIf="(uid$ | async) != 'MyAccountComponent'"
  [node]="node$ | async"
  [ngClass]="styleClass$ | async"
>
</app-custom-navigation-ui>
